import translate from './translate';

export default {
  translate: [ 'value', translate ]
};